import React from "react";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import useSnackbar from "../../hooks/useSnackbar";

import { getTransactionTransferDetails } from "../../api/transaction-type";
import { slugMap } from "../../config/slug-config";
import { Link, useParams } from "react-router-dom";
import {
  Box,
  Typography,
  Button,
  Grid,
  Tabs,
  Tab,
  CircularProgress,
} from "@mui/material";
import TabPanel from "../../components/TabPanel";
import { GridComp6, GridComp12126 } from "../../components/GridComponents";

import TransferCustom from "./transfer/custom";
import TransferGlImpact from "./transfer/gl-impact";

export default function TransactionTypeTransfer() {
  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  const params = useParams();

  const pageDetail = slugMap[params.slug];

  // const [tableRefreshCount, setTableRefreshCount] = useState(0);
  // function refreshTable () {
  //     setTableRefreshCount(prev => prev + 1);
  // }

  const [rowData, setRowData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [fromAccount, setFromAccount] = useState("");
  const [toAccount, setToAccount] = useState("");
  const [fromAccountBalance, setFromAccountBalance] = useState("");
  const [toAccountBalance, setToAccountBalance] = useState("");
  const [fromAccountCurrency, setFromAccountCurrency] = useState("");
  const [toAccountCurrency, setToAccountCurrency] = useState("");
  /*----------------Tabs-----------------*/
  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    if (user.token) {
      getTransactionTransferDetailsData();
    }
  }, []);

  async function getTransactionTransferDetailsData() {
    setLoading(true);
    try {
      const { data } = await getTransactionTransferDetails(user.token, {
        tranid: params.docNo,
      });
      setRowData(data.data.details[0]);
      setFromAccount(data.data.from_account);
      setToAccount(data.data.to_account);
      setFromAccountBalance(data.data.from_account_balance);
      setToAccountBalance(data.data.to_account_balance);
      setFromAccountCurrency(data.data.from_account_currency);
      setToAccountCurrency(data.data.to_account_currency);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      setLoading(false);
    }
  }

  return loading ? (
    <>
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography
            component="h5"
            fontWeight={500}
            className="pageHeading1"
          ></Typography>
          <Link to={"/transaction-type/" + params.slug}>
            <Button size="small" variant="contained" className="backBtn">
              Go Back
            </Button>
          </Link>
        </Box>
        <Box className="viewDetilsBox">
          <Grid container className="mb-2">
            <Grid item xs={12}>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress></CircularProgress>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  ) : (
    <>
      {/*Primary Information*/}
      <Typography component="h4" fontWeight={500} className="pageTitle">
        Transfer
      </Typography>
      <Typography component="p" style={{ marginBottom: 4 }}>
        <span className="para-no"><strong>{rowData?.tranid}</strong></span>
      </Typography>
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography
            component="h5"
            fontWeight={500}
            className="pageHeading1"
          ></Typography>
          <Link to={"/transaction-type/" + params.slug}>
            <Button size="small" className="backBtn">
              Go Back
            </Button>
          </Link>
        </Box>
        <Box className="viewDetilsBox">
          {/* {rowData.map((d, i) => ( */}
            <>
              <Grid container className="mb-2">
                <GridComp6
                  title={"TRANSACTION NUMBER"}
                  data={rowData.transaction_number}
                />
                <Grid item xs={12} sm={6} md={6}>
                  <Grid container className="mb-2">
                    <GridComp12126
                      title={"CURRENCY"}
                      data={rowData.currency}
                    />
                    <GridComp12126
                      title={"AMOUNT"}
                      data={rowData.amount}
                    />
                  </Grid>
                </Grid>
                <GridComp6 title={"TRANSFER #"} data={rowData.transfer} />
                <Grid item xs={12} sm={6} md={6}>
                  <Grid container className="mb-2">
                    <GridComp12126
                      title={"CURRENCY"}
                      d data={rowData.currency}
                    />
                    <GridComp12126
                      title={"AMOUNT"}
                      data={rowData.amount}
                    />
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <Grid container className="mb-2">
                    <GridComp12126 title={"FROM ACCOUNT"} data={rowData.from_account} />
                    <GridComp12126
                      title={"BALANCE"}
                      data={rowData.from_account_balance}
                    />
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <Grid container className="mb-2">
                    <GridComp12126
                      title={"EXCHANGE RATE"}
                      data={rowData.exchangerate}
                    />
                    <GridComp12126 title={"MEMO"} data={rowData.memo} />
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <Grid container className="mb-2">
                    <GridComp12126 title={"TO ACCOUNT"} data={rowData.to_account} />
                    <GridComp12126 title={"BALANCE"} data={rowData.to_account_balance} />
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <Grid container className="mb-2">
                    <Grid item xs={12} sm={12} md={6}>
                      &nbsp;
                    </Grid>
                    <GridComp12126 title={"SUBSIDIARY"} data={rowData.subsidiary} />
                  </Grid>
                </Grid>
                <GridComp6 title={"DATE"} data={rowData.date} />
                <GridComp6 title={"DEPARTMENT"} data={rowData.department} />
                <GridComp6 title={"POSTING PERIOD"} data={rowData.posting_period} />
                <GridComp6 title={"SERVICE LINE"} data={rowData.service_line} />
                <Grid item xs={12} sm={6} md={6}>
                  &nbsp;
                </Grid>
                <GridComp6 title={"LOCATION"} data={rowData.location} />
              </Grid>
            </>
          {/* ))} */}
        </Box>
      </Box>

      <Box>
        <Box
          className="viewBox "
          // sx={{ maxWidth: { xs: 320, sm: 480, md: "100%" }, bgcolor: "#fff" }}
        >
          <Tabs
            value={tabIndex}
            // onChange={handleChange}
            onChange={(e, nv) => {
              setTabIndex(nv);
            }}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
            className="tabs-bkg"
          >
            <Tab label="Custom" />
            <Tab label="Gl Impact" />
          </Tabs>

          {/* Custom */}
          <TabPanel value={tabIndex} index={0}>
            <TransferCustom />
          </TabPanel>
          {/* Custom */}

          {/* Gl Impact */}
          <TabPanel value={tabIndex} index={1}>
            <TransferGlImpact tabIndexP={tabIndex} />
          </TabPanel>
          {/* Gl Impact */}
        </Box>
      </Box>
    </>
  );
}
